import { render, staticRenderFns } from "./Touchpoint.vue?vue&type=template&id=8b1c514c&scoped=true&"
import script from "./Touchpoint.vue?vue&type=script&lang=js&"
export * from "./Touchpoint.vue?vue&type=script&lang=js&"
import style0 from "./Touchpoint.vue?vue&type=style&index=0&id=8b1c514c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1c514c",
  null
  
)

export default component.exports